const AltLoginAutoNavVistResponseActionName = 'AltLoginAutoNavVista';
export const getAltAutoNavResponse = (response) => {
    var _a;
    return (_a = response.responseActions) === null || _a === void 0 ? void 0 : _a.find((respAction) => (respAction.Name === AltLoginAutoNavVistResponseActionName));
};
function SetAttributes(element, attrs) {
    Object.keys(attrs).forEach(key => element.setAttribute(key, attrs[key]));
    return element;
}
const stringOrEmpty = (val) => val || '';
function submitFormData(url, formData) {
    let form = document.createElement('form');
    form = SetAttributes(form, { 'method': 'post', 'action': url });
    const dataList = Object.entries(formData);
    dataList.forEach(item => {
        const hiddenField = document.createElement('input');
        form.appendChild(SetAttributes(hiddenField, { 'type': 'hidden', 'name': item[0], 'value': stringOrEmpty(item[1]) }));
    });
    document.body.appendChild(form);
    form.submit();
}
const altLoginAutoNavVista = (response) => {
    const altLoginPostUrl = response.authorizeURI;
    const formData = {
        id_token_hint: response.idTokenHint,
        lang: "en",
    };
    submitFormData(altLoginPostUrl, formData);
};
export const altLoginAutoNav = (response, appConfig) => {
    if (response.Name === AltLoginAutoNavVistResponseActionName) {
        altLoginAutoNavVista(response);
    }
};
